module.exports = __webpack_public_path__ + "static/photo10-f8220b7dcba93a52b2a8032613465fc9.jpg";